const resolveVariable = (key: string, fallbackValue?: string): string => {
  const value = process.env[key];
  if (value || fallbackValue !== undefined) {
    return value ?? fallbackValue ?? "";
  } else {
    throw new Error(`Missing mandatory environment variable: ${key}`);
  }
};

export const config = Object.freeze({
  ADOBE_DTM_URL: resolveVariable("ADOBE_DTM_URL"),
  CLOUDWATCH_RUM_ID: resolveVariable("CLOUDWATCH_RUM_ID", ""),
  CLOUDWATCH_RUM_ENDPOINT: resolveVariable("CLOUDWATCH_RUM_ENDPOINT", ""),
  CLOUDWATCH_RUM_POOL_ID: resolveVariable("CLOUDWATCH_RUM_POOL_ID", ""),
  AUSTRALIA_CONFIRM_STATE: "AUSTRALIA.CONFIRM.STATE",
  ACCESSIBE_ELEMENT_ID: "accessibe-trigger-container",
  ACCESSIBE_SRC: "https://acsbapp.com/apps/app/dist/js/app.js",
  CPG_QUALTRICS_ID: resolveVariable("CPG_QUALTRICS_ID"),
  CPG_QUALTRICS_BRAND_ID: resolveVariable("CPG_QUALTRICS_BRAND_ID"),
  HEADER_ID: "web-core-header",
  LIVE_CHAT: {
    BUTTON_ID: resolveVariable("LIVE_CHAT_BUTTON_ID"),
    URL: resolveVariable("LIVE_CHAT_URL"),
    DEPLOYMENT_ID: "572f3000000fxSa",
    ORG_ID: resolveVariable("LIVE_CHAT_ORG_ID"),
  },
  MDC_USER_LANGUAGE: "MDC.USER.LANGUAGE",
  MDC_USER_COUNTRY: "MDC.USER.COUNTRY",
  NANOFRONTENDS_PORT: process.env.NANOFRONTENDS_PORT,
  AWS_REGION: resolveVariable("AWS_REGION", "us-east-1"),
  ROUTES: {
    ERROR: "/error",
    NOT_FOUND: "/page-not-found",
  },
  SPLIT_SDK: {
    authorizationKey: resolveVariable("SPLIT_API_KEY", "localhost"),
  },
  WALKME_URL: resolveVariable("WALKME_URL"),
});
